import React from 'react';
import { Link } from 'react-router-dom';
import { Wind, Truck, Package, Clock, MapPin } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ShippingInfo = () => {
  return (
    <div className="min-h-screen bg-dark-primary">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-dark-primary/80 backdrop-blur-lg border-b border-gold/10">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <Wind className="w-8 h-8 text-gold" />
            <span className="text-2xl font-bold text-gold">MADTOYS</span>
          </Link>
          <Link to="/" className="text-gray-300 hover:text-gold transition-colors">
            ← Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="text-5xl font-bold text-white mb-6">Shipping Information</h1>
          <p className="text-xl text-gray-400 mb-12">Fast and reliable delivery across India</p>

          <div className="space-y-8">
            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gold/10 rounded-lg">
                    <Truck className="w-6 h-6 text-gold" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-white mb-3">Delivery Coverage</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We deliver across all major cities and towns in India. Standard delivery is available 
                      to all pin codes serviced by our courier partners.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gold/10 rounded-lg">
                    <Clock className="w-6 h-6 text-gold" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-white mb-3">Delivery Timeline</h2>
                    <div className="space-y-4 text-gray-300">
                      <div className="flex justify-between py-2 border-b border-gray-700">
                        <span className="font-semibold text-gold">Metro Cities</span>
                        <span>3-5 business days</span>
                      </div>
                      <div className="flex justify-between py-2 border-b border-gray-700">
                        <span className="font-semibold text-gold">Other Cities</span>
                        <span>5-7 business days</span>
                      </div>
                      <div className="flex justify-between py-2">
                        <span className="font-semibold text-gold">Remote Areas</span>
                        <span>7-10 business days</span>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gold/10 rounded-lg">
                    <Package className="w-6 h-6 text-gold" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-white mb-3">Shipping Charges</h2>
                    <p className="text-gray-300 leading-relaxed mb-4">
                      <span className="text-gold font-bold text-xl">FREE SHIPPING</span> on all orders across India!
                    </p>
                    <p className="text-gray-400 text-sm">
                      No minimum order value required. We believe in providing the best value to our customers.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gold/10 rounded-lg">
                    <MapPin className="w-6 h-6 text-gold" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-white mb-3">Order Tracking</h2>
                    <p className="text-gray-300 leading-relaxed">
                      Once your order is shipped, you'll receive a tracking number via email and SMS. 
                      You can track your package in real-time through our courier partner's website.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Packaging</h2>
                <p className="text-gray-300 leading-relaxed">
                  Every MADTOYS product is carefully packaged to ensure it reaches you in perfect condition. 
                  Our windmill night light comes in a premium gift box, making it perfect for gifting or personal use.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-dark-secondary border-gold/20">
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-white mb-4">Important Notes</h2>
                <ul className="space-y-3 text-gray-300">
                  <li className="flex items-start gap-3">
                    <span className="text-gold mt-1">•</span>
                    <span>Orders are processed within 24-48 hours on business days</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-gold mt-1">•</span>
                    <span>Delivery times may vary during festive seasons or due to unforeseen circumstances</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-gold mt-1">•</span>
                    <span>Please ensure someone is available to receive the package at the delivery address</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-gold mt-1">•</span>
                    <span>For any shipping queries, contact us at info@madtoys.in</span>
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingInfo;
